import { render, staticRenderFns } from "./NumericalInput.vue?vue&type=template&id=2ff8a8c2&"
import script from "./NumericalInput.vue?vue&type=script&lang=js&"
export * from "./NumericalInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports